const URL = "https://majorproject-backend-dfac.onrender.com/api/v1";
export default URL;
